<template>
  <div>
    <v-container grid-list-xl fluid class="white pl-6 pr-5 pt-6">
      <v-layout row wrap class="pr-5 pl-2">
        <v-flex class="py-0">
          <h2 class="primary--text breadcrumbs fs-16 lh-29 font-weight-700">
            Monthly Consolidated PO
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-breadcrumbs
          class="px-0 fs-12 lh-15 py-0 breadcrumbs-items custom-breadcrumbs text-uppercase"
          :items="breadcrumbs"
        ></v-breadcrumbs>
      </v-layout>
    </v-container>

    <v-layout class="tab-monthly">
      <v-tabs v-model="tab" background-color="white" color="menuActive">
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="(item, index) in entities"
          :key="index"
          :to="{ name: 'consolidated-report-po', params: { id: item.initial } }"
          class="text-left px-0 d-block pt-3 mr-10"
          style="min-width: 100px !important; height:100%"
        >
          <span class="text-capitalize fs-12 font-weight-600 text-left">
            {{ item.name }}
          </span>
        </v-tab>
      </v-tabs>
      <v-flex xs3 class="pr-8 white pt-2">
        <date-picker
          v-model="year"
          type="month"
          placeholder="Start Date"
          format="MMMM YYYY"
          class="date-font fs-12"
          dense
        />
      </v-flex>
    </v-layout>
    <v-row>
      <v-col cols="12">
        <table-consolidate-po
          :itemsTable="itemSH"
          :tab="id"
          @getData="getConsolidatePO(id)"
        >
        </table-consolidate-po>
      </v-col>
    </v-row>
    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import Swal from 'sweetalert2';
// import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
// import { arrayToParam } from '@/utils/helpers';
import tableConsolidatePO from '../../../components/monthlyReport/tableConsolidatePO';

export default {
  name: 'SpendingReportIndex',
  components: {
    'progress-dialog': ProgressDialog,
    'table-consolidate-po': tableConsolidatePO
  },
  mixins: [ACLMixin],
  props: ['id'],
  data() {
    return {
      year: new Date(),
      progressDialogLoading: false,
      filters: '',
      entities: [
        {
          id: 0,
          name: 'SN Indonesia',
          initial: 'all'
        },
        {
          id: 1,
          name: 'SH',
          initial: 'sh'
        },
        {
          id: 2,
          name: 'NIS',
          initial: 'nis'
        },
        {
          id: 3,
          name: 'NMN',
          initial: 'nmn'
        }
      ],
      tab: 0,
      consolidateItems: [],
      itemSH: [],
      breadcrumbs: [
        {
          text: 'Monthly report',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'consolidated po report',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  watch: {
    '$route.params.id'(val) {
      this.getConsolidatePO(val);
    },
    year() {
      this.getConsolidatePO(this.id);
    }
  },
  computed: {
    ...mapState('auth', ['userRole']),
    ...mapGetters('auth', ['userMapping'])
  },
  async mounted() {
    this.filters = JSON.parse(localStorage.getItem('filters'));
    // await this.setFilter(0);
    this.getConsolidatePO(this.id);
    // this.progressDialogLoading = false;
  },
  methods: {
    async getConsolidatePO(name) {
      let entity = name || this.$route.params.id;
      this.progressDialogLoading = true;
      await this.$store
        .dispatch('monthlyReport/getConsolidatePO', {
          paginate: false,
          entity: entity,
          date: this.formattedDate(this.year)
        })
        .then(data => {
          if (data.code === 200) {
            this.itemSH = data.data.map(val => {
              return {
                ...val,
                formatted_po: this.formatDate(val.po_date),
                formatted_delivery: this.formatDate(val.delivery_date),
                formatted_fiscal: this.formatDate(val.fiscal_year),
                formatted_invoice: this.formatDate(val.invoice_document_date),
                formatted_posting: this.formatDate(val.invoice_posting_date)
              };
            });
            this.progressDialogLoading = false;
          } else {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    },
    setFilter(index) {
      let entityName = '';
      switch (index) {
        case 0:
          entityName = 'all';
          break;
        case 1:
          entityName = 'sh';
          break;
        case 2:
          entityName = 'nis';
          break;
        case 3:
          entityName = 'nmn';
          break;
      }
      // if (this.itemSH[index].data.length === 0) {
      this.getConsolidatePO(entityName);
      // }
    }
  }
};
</script>
<style scoped>
.drawer-menu--scroll {
  max-height: 340px;
  overflow: auto;
}
.drawer-menu--scrollEdit {
  max-height: 450px;
  overflow: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid rgb(151, 151, 151);
}
</style>
